<div class="wrapper__headerComponent container my-5">
  <div class="row">
    <div class="d-flex flex-row align-items-start">
      <img
        src="../../../../assets/img/file-alt.svg"
        alt="logo"
        class="img-ico-form" />
      <h2 class="mb-0">{{ sfcText['sfc-procon']['titulo'] }}</h2>
    </div>
  </div>
  <div class="container-example-linea-avance-govco mx-0 my-5">
    <div
      class="linea-avance-govco ih-linea-avance-govco m-0 p-0"
      id="lineaAvance3">
      <div class="px-5">
        <div class="progress">
          <div
            class="progress-bar"
            role="progressbar"
            style="width: 15%"
            aria-valuenow="15"
            aria-valuemin="0"
            aria-valuemax="100"></div>
        </div>
        <div class="items-header-linea-avance-govco">
          <div class="header-linea-avance-govco active-linea-avance-govco">
            <button
              class="indicator-linea-avance-govco"
              type="button"
              data-la-target="#itemlineaAvance31"
              percentage="17"
              onClick="clickHorizontalAdvanceLine(event)"
              aria-label="Atrás">
              <span>1</span>
            </button>
            <span class="title-linea-avance-govco">{{
              comunText['datos-demandante']
            }}</span>
          </div>
          <div class="header-linea-avance-govco">
            <button
              class="indicator-linea-avance-govco"
              type="button"
              data-la-target="#itemlineaAvance32"
              percentage="34"
              onClick="clickHorizontalAdvanceLine(event)"
              aria-label="Atrás">
              <span>2</span>
            </button>
            <span class="title-linea-avance-govco">{{
              sfcText['tramite-sic-comp-desleal']['apoderado']
            }}</span>
          </div>
          <div class="header-linea-avance-govco">
            <button
              class="indicator-linea-avance-govco"
              type="button"
              data-la-target="#itemlineaAvance33"
              percentage="51"
              onClick="clickHorizontalAdvanceLine(event)"
              aria-label="Atrás">
              <span>3</span>
            </button>
            <span class="title-linea-avance-govco">{{
              comunText['datos-demandado']
            }}</span>
          </div>
          <div class="header-linea-avance-govco">
            <button
              class="indicator-linea-avance-govco"
              type="button"
              data-la-target="#itemlineaAvance34"
              percentage="68"
              onClick="clickHorizontalAdvanceLine(event)"
              aria-label="Atrás">
              <span>4</span>
            </button>
            <span class="title-linea-avance-govco">{{
              sfcText['sfc-procon']['detalle-inconformidad']
            }}</span>
          </div>
          <div class="header-linea-avance-govco">
            <button
              class="indicator-linea-avance-govco"
              type="button"
              data-la-target="#itemlineaAvance35"
              percentage="85"
              onClick="clickHorizontalAdvanceLine(event)"
              aria-label="Atrás">
              <span>5</span>
            </button>
            <span class="title-linea-avance-govco">{{
              sfcText['tramite-sic-procon']['reclamo-directo']
            }}</span>
          </div>
          <div class="header-linea-avance-govco">
            <button
              class="indicator-linea-avance-govco"
              type="button"
              data-la-target="#itemlineaAvance36"
              percentage="100"
              onClick="clickHorizontalAdvanceLine(event)"
              aria-label="Atrás">
              <span>6</span>
            </button>
            <span class="title-linea-avance-govco">{{
              sfcText['tramite-sic-procon']['notificaciones']
            }}</span>
          </div>
        </div>
      </div>
      <!-- Demandante -->
      <div
        id="itemlineaAvance31"
        class="body-linea-avance-govco active-linea-avance-govco"
        data-la-parent="#lineaAvance3">
        <!-- Justino -->
        <app-recuadro-justino></app-recuadro-justino>
        <div class="contents-linea-avance-govco">
          <div class="contents-example-linea-avance-govco">
            <app-sfc-demandante
              (continuar)="siguiente($event, 1)"
              (guardarSinEnviar)="guardarSinEnviarTramite($event)"
              [tramiteSfc]="tramiteSfc"
              [archivosPreCargados]="archivosPreCargados"
              (demandanteEmit)="getFormDemandante($event)"/>
          </div>
        </div>
      </div>
      <!-- Apoderado -->
      <div
        id="itemlineaAvance32"
        class="body-linea-avance-govco"
        data-la-parent="#lineaAvance3">
        <div class="contents-linea-avance-govco">
          <div class="contents-example-linea-avance-govco">
            <app-sfc-apoderado
              (continuar)="siguiente($event, 2)"
              (guardarSinEnviar)="guardarSinEnviarTramite($event)"
              [tramiteSfc]="tramiteSfc"
              [archivosPreCargados]="archivosPreCargados"
              (apoderadoEmit)="getFormApoderado($event)"/>
          </div>
        </div>
      </div>
      <!-- Demandado -->
      <div
        id="itemlineaAvance33"
        class="body-linea-avance-govco"
        data-la-parent="#lineaAvance3">
        <div class="contents-linea-avance-govco">
          <div class="contents-example-linea-avance-govco">
            <app-sfc-demandado
              (continuar)="siguiente($event, 3)"
              (guardarSinEnviar)="guardarSinEnviarTramite($event)"
              [tramiteSfc]="tramiteSfc" 
              (demandadoEmit)="getFormDemandado($event)"/>
          </div>
        </div>
      </div>
      <!-- Detalle -->
      <div
        id="itemlineaAvance34"
        class="body-linea-avance-govco"
        data-la-parent="#lineaAvance3">
        <div class="contents-linea-avance-govco">
          <div class="contents-example-linea-avance-govco">
            <app-sfc-detalle
            (continuar)="siguiente($event, 4)"
            (guardarSinEnviar)="guardarSinEnviarTramite($event)"
            [tramiteSfc]="tramiteSfc"
            (detalleEmit)="getFormDetalle($event)"/>
          </div>
        </div>
      </div>
      <!-- Reclamo -->
      <div
        id="itemlineaAvance35"
        class="body-linea-avance-govco"
        data-la-parent="#lineaAvance3">
        <div class="contents-linea-avance-govco">
          <div class="contents-example-linea-avance-govco">
            <app-sfc-reclamo
            *ngIf="festivos.length>0"
            (continuar)="siguiente($event, 5)"
            (guardarSinEnviar)="guardarSinEnviarTramite($event)"
            [tramiteSfc]="tramiteSfc"
            (reclamoEmit)="getFormReclamo($event)"/>
          </div>
        </div>
      </div>
      <!-- Notificaiones -->
      <div
        id="itemlineaAvance36"
        class="body-linea-avance-govco"
        data-la-parent="#lineaAvance3">
        <div class="contents-linea-avance-govco">
          <div class="contents-example-linea-avance-govco">
            <app-sfc-notificaciones
              *ngIf="ultimoPaso"
              [tramiteSfc]="tramiteSfc"
              (guardarSinEnviarTramite)="guardarSinEnviarTramite($event)"
              (enviarTramite)="enviarTramite($event)"
              (notificacionesEmit)="getFormNotificaciones($event)" />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>